import * as React from "react";
import { useLocation, useParams } from "react-router";
import { AlertMessage, AlertType, ButtonType, CustomButton, SpinnerWrapper } from "soprasteria-ui-library";
import { useAuth } from "../../../App";
import { ResidenceApi } from "../../../api/ResidenceApi";
import { UserContext, isInRole } from "../../../contexts/UserContext";
import { setMessage } from "../../../helpers/MessageHelper";
import { IResidence } from "../../../models/IResidence";
import { MENUETTPORTALKOMMUN_BOENDESAMORDNARE } from "../../../utils/RoleConstants";
import { NavigateBackFooter } from "../../NavigateBackFooter/NavigateBackFooter";
import { EditResidenceModal } from "./EditResidenceModal";
import { ResidenceInformation } from "./ResidenceInformation";

export const Residence: React.FC<{}> = () => {
    const auth = useAuth();
    const api = new ResidenceApi(auth);
    const userInfo = React.useContext(UserContext);
    const hasRoleBoendesamordnare = isInRole(MENUETTPORTALKOMMUN_BOENDESAMORDNARE, userInfo.roles ? userInfo.roles : []);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [successMessage, setSuccessMessage] = React.useState<string>("");
    const [residence, setResidence] = React.useState<IResidence>();
    const { id } = useParams<{ id: string }>();
    const location = useLocation();
    const [renderModal, setRenderModal] = React.useState<boolean>(false);

    React.useEffect(() => {
        loadResidence(parseInt(id));
    }, [, location]);

    const loadResidence = (residenceId: number) => {
        setIsLoading(true);
        api.getResidenceById(residenceId, (result) => {
            setResidence(result);
        }, (error) => { setErrorMessage(error) }, () => { setIsLoading(false); });
    }

    const closeModal = () => {
        setRenderModal(false);
    }

    const onSubmit = (residenceId: number) => {
        document.getElementById("close-edit-residence-modal")?.click();
        loadResidence(residenceId);
        setSuccessMessage(setMessage("Boendeenheten har sparats", successMessage));
    }

    return (
        <SpinnerWrapper isLoading={isLoading}>
            <section className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col">
                            <h1>Boendeuppgifter</h1>
                        </div>
                        <div className="col">
                            <div className="text-right">
                                {
                                    hasRoleBoendesamordnare &&
                                    <CustomButton buttonText="Redigera boendeenhet" buttonType={ButtonType.edit} onClick={() => setRenderModal(true)} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="col-12">
                        <AlertMessage alertType={AlertType.success} duration={5000} >{successMessage}</AlertMessage>
                        <AlertMessage alertType={AlertType.danger} duration={5000}>{errorMessage}</AlertMessage>
                    </div>
                    {
                        residence &&
                            <>
                                <div className="relative">
                                    <div className="row">
                                    <ResidenceInformation residence={residence} />
                                    </div>
                                </div>
                             </>
                    }

                </div>
                <NavigateBackFooter />
                {
                    residence && renderModal &&
                        <EditResidenceModal residence={residence} closeModal={closeModal} onSubmit={onSubmit} />
                }
            </section>
        </SpinnerWrapper>
    );
}